import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { SubmitButton } from '@/components/ui/app/submit-button';
import FormCompanyEdit, { FORM_COMPANY_EDIT_ID } from '../forms/FormCompanyEdit';
import { useTranslation } from 'react-i18next';

export default function SheetCompanyEdit({
    open,
    onClose,
    company,
    companyLogoUrl,
    onSubmit,
    resetKey,
    isSubmitting = false,
}) {
    const { t } = useTranslation();
    return (
        <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <SheetContent className="w-[90vw] sm:w-[480px] sm:max-w-[480px] flex flex-col p-0">
                <SheetHeader className="px-6 py-4 border-b border-border">
                    <SheetTitle className="text-lg font-semibold text-foreground">{t('account:modifierLesInformations')}</SheetTitle>
                </SheetHeader>

                <FormCompanyEdit key={resetKey} company={company} companyLogoUrl={companyLogoUrl} onSubmit={onSubmit} />

                <SheetFooter className="px-6 py-4 border-t border-border flex items-center justify-between gap-3">
                    <Button
                        type="button"
                        variant="soft"
                        color="neutral"
                        className="px-4 py-3 rounded-lg"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        {t('account:annuler')}
                    </Button>
                    <SubmitButton
                        form={FORM_COMPANY_EDIT_ID}
                        className="px-6 py-3 rounded-lg"
                        isSubmitting={isSubmitting}
                        loadingText={t('account:enregistrement')}
                    >
                        {t('account:enregistrer')}
                    </SubmitButton>
                </SheetFooter>
            </SheetContent>
        </Sheet>
    );
}
